// Overrides the viewport loading-overlay label for non-colour loads that reuse the
// `isColorLoading` overlay (e.g. alloy SwapSku swaps, which otherwise show no feedback).
// Module-level on purpose: the label is read during the overlay's render, and that render
// is already triggered by the `isColorLoading` store change — so the label just needs to be
// set BEFORE setColorLoading(true) and cleared AFTER setColorLoading(false).
// `null` → the default "Applying color…" label.
let _label: string | null = null;

export const setViewportLoaderText = (label: string | null): void => {
  _label = label;
};

export const getViewportLoaderText = (): string | null => _label;
